<template>
<div class="assets-tab-list-container">
<!-- 搜索框 -->
<div class="search-box">
<el-input
v-model="searchKeyword"
placeholder="搜索资产名称/编码..."
prefix-icon="el-icon-search"
size="small"
clearable
@keyup.enter.native="doSearch"
@clear="onSearchClear"
/>
<el-button
  size="small"
  class="search-btn"
  :loading="searching"
  @click="doSearch"
>搜索</el-button>
</div>
<!-- 使用 el-tabs 作为顶部标签，搜索模式下隐藏 -->
<el-tabs v-if="!isSearchMode" v-model="activeTab" class="custom-tabs" @tab-click="handleTabClick">
<el-tab-pane v-for="tab in tabs" :key="tab.id" :name="tab.id" :label="tab.label">
</el-tab-pane>
</el-tabs>
<div class="seamless-scroll-content" @click="scrollClickHandler">
<!-- 轮播模式（非搜索） -->
<vue-seamless-scroll v-if="!isSearchMode" :data="getCurrentData()" :class-option="classOption" class="list-container"
ref="scrollContainer">
<!-- 存量资产列表 -->
<div v-show="activeTab === 'stock'" class="asset-list stock-assets">
<div v-for="(item) in stockAssets" :key="item.id" class="list-item"
:data-obj="JSON.stringify(item)">
<div class="item-main">
<div class="item-title">{{ item.assetName }}</div>
<span class="status-badge" :class="getTypeClass(item.assetType)">
{{ item.assetType }}
</span>
</div>
<div class="item-details">
<span class="share" :class="getStatusClass(item.status)">
状态：{{ item.status }}
</span>
<span class="time">时间：{{ item.createTime }}</span>
</div>
</div>
<div v-if="stockAssets.length === 0" class="empty-tip">
<i class="el-icon-files"></i>
<p>暂无存量资产数据</p>
</div>
</div>

<!-- 不良资产列表 -->
<div v-show="activeTab === 'nonPerforming'" class="asset-list non-performing-assets">
<div v-for="(item) in nonPerformingAssets" :key="item.id" class="list-item"
:data-obj="JSON.stringify(item)">
<div class="item-main">
<div class="item-title">{{ item.assetName }}
<el-tag v-if="item.assetCode" size="small" class="codetag">编码：{{ item.assetCode }}</el-tag>
</div>
<span class="status-badge" :class="getTypeClass(item.assetType)">
{{ item.assetType }}
</span>
</div>
<div class="item-details">
<span class="time">时间：{{ item.createTime || '--' }}</span>
</div>
</div>
<div v-if="nonPerformingAssets.length === 0" class="empty-tip">
<i class="el-icon-warning-outline"></i>
<p>暂无不良资产数据</p>
</div>
</div>

<!-- 股权资产列表 -->
<div v-show="activeTab === 'equity'" class="asset-list equity-assets">
<div v-for="(item) in equityAssets" :key="item.id" class="list-item"
:data-obj="JSON.stringify(item)">
<div class="item-main">
<div class="item-title">{{ item.assetName }}
<el-tag v-if="item.assetCode" size="small" class="codetag">编码：{{ item.assetCode }}</el-tag>
</div>
<span class="status-badge" :class="getTypeClass(item.assetType)">
{{ item.assetType }}
</span>
</div>
<div class="item-details">
<span class="share warning">状态：{{ item.status || '--' }}</span>
<span class="time">持股比例：{{ item.shareRatio || '--' }}%</span>
</div>
</div>
<div v-if="equityAssets.length === 0" class="empty-tip">
<i class="el-icon-s-data"></i>
<p>暂无股权资产数据</p>
</div>
</div>
</vue-seamless-scroll>

<!-- 搜索结果模式：不显示tab，三类结果合并展示 -->
<div v-else class="list-container search-result-list">
<template v-if="searchResultList.length > 0">
<div v-for="(item, idx) in searchResultList" :key="idx" class="list-item"
:data-obj="JSON.stringify(item)">
<div class="item-main">
<div class="item-title">{{ item.assetName }}
<el-tag v-if="item.assetCode" size="small" class="codetag">{{ item.assetCode }}</el-tag>
</div>
<span class="status-badge" :class="getTypeClass(item.assetType)">
{{ item.assetType }}
</span>
</div>
<div class="item-details">
<span class="share" :class="getStatusClass(item.status)">
{{ item.status ? '状态：' + item.status : (item.assetPackageCategory ? '类别：' + item.assetPackageCategory : '管理员：' + (item.manager || '--')) }}
</span>
<span class="time">时间：{{ item.createTime }}</span>
</div>
</div>
</template>
<div v-else class="empty-tip">
<i class="el-icon-search"></i>
<p>未找到相关资产数据</p>
</div>
</div>
</div>
</div>
</template>

<script>
import vueSeamlessScroll from 'vue-seamless-scroll';
import apis from '@/http/apis';
import chartClickMixin from "@/views/index/components/handlemixin.js";
export default {
mixins: [chartClickMixin],
name: 'AssetsTabList',
components: {
vueSeamlessScroll
},
computed: {
filteredStockAssets() {
return this.stockAssets || [];
},
filteredNonPerformingAssets() {
return this.nonPerformingAssets || [];
},
filteredEquityAssets() {
return this.equityAssets || [];
},
},
data() {
return {
activeTab: 'stock',
searchKeyword: '',
searching: false,
isSearchMode: false,
tabs: [
{ id: 'stock',        label: '存量资产', icon: 'el-icon-office-building' },
{ id: 'nonPerforming', label: '不良资产', icon: 'el-icon-warning' },
{ id: 'equity',       label: '股权资产', icon: 'el-icon-s-data' }
],
stockAssets: [],
nonPerformingAssets: [],
equityAssets: [],
searchResultList: [],
_origStock: [],
_origNonPerforming: [],
_origEquity: [],
classOption: {
direction: 1,
limitMoveNum: 1,
step: 0.5,
openWatch: true,
singleHeight: 0,
singleWidth: 0,
waitTime: 1000,
autoPlay: true,
}
};
},
created() {
this.loadListData();
},
mounted() {
this.updateScrollConfig();
window.addEventListener('resize', this.updateScrollConfig);
if (this.$bus) {
this.$bus.$on('pause-dashboard-animations', this.onPauseDashboardAnimations);
}
},
beforeDestroy() {
window.removeEventListener('resize', this.updateScrollConfig);
if (this.$bus) {
this.$bus.$off('pause-dashboard-animations', this.onPauseDashboardAnimations);
}
},
watch: {
activeTab() {
this.$emit('tab-change', this.activeTab);
}
},
methods: {
onPauseDashboardAnimations(paused) {
this.classOption.autoPlay = !paused;
},
handleTabClick(tab) {
console.log('切换tab:', tab.name);
},
loadListData() {
apis.stockAssetList().then((res) => {
this.stockAssets = res && res.data && res.data.list ? res.data.list : [];
this._origStock = this.stockAssets;
this.updateScrollConfig();
});
apis.nonPerformingAssetList().then((res) => {
this.nonPerformingAssets = res && res.data && res.data.list ? res.data.list : [];
this._origNonPerforming = this.nonPerformingAssets;
});
apis.equityAssetList().then((res) => {
this.equityAssets = res && res.data && res.data.list ? res.data.list : [];
this._origEquity = this.equityAssets;
});
},
doSearch() {
const kw = (this.searchKeyword || '').trim();
if (!kw) {
this.onSearchClear();
return;
}
this.searching = true;
this.pauseScroll();
apis.searchAssets(kw).then((res) => {
const data = res && res.data ? res.data : {};
this.stockAssets = data.stockList || [];
this.nonPerformingAssets = data.nonPerformingList || [];
this.equityAssets = data.equityList || [];
this.searchResultList = [
  ...this.stockAssets,
  ...this.nonPerformingAssets,
  ...this.equityAssets
];
this.isSearchMode = true;
this.updateScrollConfig();
this.resumeScroll();
}).catch(() => {
this.$message && this.$message.error('搜索失败，请稍后重试');
}).finally(() => {
this.searching = false;
});
},
onSearchClear() {
this.searchKeyword = '';
if (this.isSearchMode) {
this.stockAssets = this._origStock;
this.nonPerformingAssets = this._origNonPerforming;
this.equityAssets = this._origEquity;
this.searchResultList = [];
this.isSearchMode = false;
this.updateScrollConfig();
}
this.resumeScroll();
},
scrollClickHandler(e) {
try {
let data;
let target = e.target;
while (target && !data) {
if (target.dataset.obj) {
data = JSON.parse(target.dataset?.obj || "{}");
}
target = target.parentElement;
}
this.setupChartClick(data, 'list');
} catch (error) {
console.log("JSON parse error", error);
}
},
pauseScroll() {
if (this.$refs.scrollContainer && this.$refs.scrollContainer.seamless) {
this.$refs.scrollContainer.seamless._stopMove();
}
},
resumeScroll() {
if (this.$refs.scrollContainer && this.$refs.scrollContainer.seamless) {
this.$refs.scrollContainer.seamless._startMove();
}
},
getCurrentData() {
switch (this.activeTab) {
case 'stock': return this.filteredStockAssets;
case 'nonPerforming': return this.filteredNonPerformingAssets;
case 'equity': return this.filteredEquityAssets;
default: return [];
}
},
getTabData(tabId) {
switch (tabId) {
case 'stock': return this.stockAssets;
case 'nonPerforming': return this.nonPerformingAssets;
case 'equity': return this.equityAssets;
default: return [];
}
},
handleItemClick(item, tabType) {
this.$emit('item-click', { tab: tabType, data: item });
},
getStatusClass(status) {
const statusMap = {
'待出租': 'status-building',
'部分出租': 'status-normal',
'其他': 'status-written-off',
};
return statusMap[status] || '';
},
getTypeClass(type) {
const typeMap = {
'存量资产': 'type-building',
'不良资产': 'type-normal',
'股权资产': 'type-written-off',
};
return typeMap[type] || '';
},
updateScrollConfig() {
const itemHeight = 91;
this.classOption.singleHeight = itemHeight;
const currentData = this.getCurrentData();
const itemCount = currentData.length;
if (itemCount > 8) {
this.classOption.step = 0.8;
this.classOption.waitTime = 800;
} else if (itemCount > 4) {
this.classOption.step = 0.6;
this.classOption.waitTime = 1000;
} else {
this.classOption.step = 0.4;
this.classOption.waitTime = 1200;
}
},
}
};
</script>

<style lang="scss" scoped>
$fontsize: 13px;

.assets-tab-list-container {
width: 100%;
height: 100%;
border-radius: 8px;
display: flex;
flex-direction: column;
overflow: hidden;
position: relative;
}

.search-box {
padding: 4px 8px;
flex-shrink: 0;
display: flex;
align-items: center;
gap: 6px;
}

.search-btn {
flex-shrink: 0;
height: 26px;
padding: 0 10px;
font-size: 12px;
background: rgba(1, 228, 255, 0.15);
border: 1px solid rgba(1, 228, 255, 0.5);
color: rgba(1, 228, 255, 0.9);
border-radius: 4px;
}
.search-btn:hover, .search-btn:focus {
background: rgba(1, 228, 255, 0.3);
border-color: rgba(1, 228, 255, 0.8);
color: #fff;
}

::v-deep .search-box .el-input__inner {
background: rgba(0, 20, 50, 0.8);
border: 1px solid rgba(1, 228, 255, 0.35);
color: rgba(255, 255, 255, 0.9);
font-size: 12px;
height: 26px;
line-height: 26px;
border-radius: 4px;
}
::v-deep .search-box .el-input__inner::placeholder { color: rgba(255, 255, 255, 0.35); }
::v-deep .search-box .el-input__inner:focus { border-color: rgba(1, 228, 255, 0.7); box-shadow: 0 0 6px rgba(1, 228, 255, 0.25); }
::v-deep .search-box .el-input__prefix { color: rgba(1, 228, 255, 0.8); line-height: 26px; }
::v-deep .search-box .el-input__suffix { line-height: 26px; }
::v-deep .search-box .el-input__icon { line-height: 26px; }

.custom-tabs {
padding: 5px;
flex-shrink: 0;
backdrop-filter: blur(10px);
border-radius: 8px 8px 0 0;
position: relative;
z-index: 1;
}

::v-deep .custom-tabs .el-tabs__header { margin: 0; border-bottom: 1px solid rgba(1, 228, 255, 0.2); }
::v-deep .custom-tabs .el-tabs__nav-wrap { padding: 0 10px; }
::v-deep .custom-tabs .el-tabs__nav { display: flex; width: 100%; }
::v-deep .custom-tabs .el-tabs__item {
flex: 1;
text-align: center;
padding: 0px 5px !important;
color: rgba(255, 255, 255, 0.7) !important;
font-size: 14px;
transition: all 0.3s ease;
position: relative;
height: 30px !important;
line-height: 30px !important;
}
::v-deep .custom-tabs .el-tabs__item:hover { color: #01E4FF !important; }
::v-deep .custom-tabs .el-tabs__item.is-active { color: #01E4FF !important; font-weight: bold; }
::v-deep .custom-tabs .el-tabs__active-bar {
height: 2px !important;
bottom: 0 !important;
background: linear-gradient(90deg, transparent, #01E4FF, transparent) !important;
}
::v-deep .custom-tabs .el-tabs__nav-wrap::after { display: none; }

.seamless-scroll-content {
flex: 1;
overflow: hidden;
}

.search-result-list {
overflow-y: auto;
}
.search-result-list::-webkit-scrollbar { width: 3px; }
.search-result-list::-webkit-scrollbar-thumb { background: rgba(1, 228, 255, 0.3); border-radius: 2px; }
.search-result-list::-webkit-scrollbar-track { background: transparent; }

.list-container {
flex: 1;
overflow: hidden;
padding: 5px;
position: relative;
height: 100%;
}

.list-item {
position: relative;
padding: 10px 15px;
margin-bottom: 10px;
background: rgba(255, 255, 255, 0.08);
backdrop-filter: blur(5px);
border-radius: 6px;
border: 1px solid rgba(255, 255, 255, 0.1);
cursor: pointer;
transition: all 0.3s ease;
overflow: hidden;
}
.list-item:hover {
background: rgba(255, 255, 255, 0.12);
border-color: rgba(1, 228, 255, 0.4);
transform: translateY(-2px);
box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.item-main {
display: flex;
justify-content: space-between;
align-items: center;
margin-bottom: 8px;
}
.item-title {
color: #ffffff;
font-size: 14px;
font-weight: 500;
flex: 1;
overflow: hidden;
text-overflow: ellipsis;
white-space: nowrap;
}
.item-details {
display: flex;
justify-content: space-between;
align-items: center;
font-size: 12px;
}

.status-badge {
padding: 4px 10px;
border-radius: 12px;
font-size: 11px;
font-weight: 500;
flex-shrink: 0;
margin-left: 8px;
}

.status-normal  { background: rgba(0, 255, 0, 0.1); color: #00ff00; border: 1px solid rgba(0, 255, 0, 0.3); }
.status-building { background: rgba(255, 165, 0, 0.1); color: #FFA500; border: 1px solid rgba(255, 165, 0, 0.3); }
.status-written-off { background: rgba(220, 220, 220, 0.1); color: #f5f5f5; border: 1px solid rgba(220, 220, 220, 0.3); }

.type-building { background: rgba(255, 165, 0, 0.1); color: #FFA500; border: 1px solid rgba(255, 165, 0, 0.3); }
.type-normal   { background: rgba(88, 175, 255, 0.1); color: #72d5ff; border: 1px solid rgba(88, 175, 255, 0.3); }
.type-written-off { background: rgba(37, 186, 0, 0.1); color: #25ba00; border: 1px solid rgba(37, 186, 0, 0.3); }

.time  { color: rgba(255, 255, 255, 0.6); font-size: 12px; }
.share { color: #FFD93D; font-size: 12px; padding: 3px 8px; background: rgba(255, 217, 61, 0.1); border-radius: 4px; }
.warning { color: #FF6B6B; background: rgba(255, 107, 107, 0.1); }

.codetag {
margin-left: 5px;
background-color: #ecf5ff4f;
border-color: #59acff;
font-size: $fontsize;
color: #fff;
}

.empty-tip {
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
height: 120px;
color: rgba(255, 255, 255, 0.4);
font-size: 13px;
}
.empty-tip i { font-size: 28px; margin-bottom: 8px; }
</style>